import { FILE_STATUSES } from "../../js/api/filePacket/constants";
import { emptyFileFilters } from "../../js/api/filePacket/search";

export default function FileSearchBar({ filters, agents = [], onChange, idPrefix = "file-search" }) {
  const value = { ...emptyFileFilters(), ...filters };

  function update(name, next) {
    onChange({ ...value, [name]: next });
  }

  return (
    <form className="file-search" onSubmit={(event) => event.preventDefault()}>
      <label className="file-search__query">
        <span className="field-label">Search files</span>
        <input
          id={`${idPrefix}-query`}
          type="search"
          value={value.query}
          onChange={(event) => update("query", event.target.value)}
          placeholder="Name, email, phone, address, status, or agent"
        />
      </label>
      <label>
        <span className="field-label">Status</span>
        <select value={value.status} onChange={(event) => update("status", event.target.value)}>
          <option value="">Any status</option>
          {FILE_STATUSES.map((item) => (
            <option key={item.id} value={item.id}>
              {item.label}
            </option>
          ))}
        </select>
      </label>
      <label>
        <span className="field-label">Agent</span>
        <select value={value.agent} onChange={(event) => update("agent", event.target.value)}>
          <option value="">Any agent</option>
          {agents.map((agent) => (
            <option key={agent.id} value={agent.id}>
              {agent.name}
            </option>
          ))}
        </select>
      </label>
      <label>
        <span className="field-label">File type</span>
        <select value={value.fileType} onChange={(event) => update("fileType", event.target.value)}>
          <option value="">Buyer or seller</option>
          <option value="buyer">Buyer</option>
          <option value="seller">Seller</option>
        </select>
      </label>
      <label>
        <span className="field-label">From</span>
        <input type="date" value={value.from} onChange={(event) => update("from", event.target.value)} />
      </label>
      <label>
        <span className="field-label">To</span>
        <input type="date" value={value.to} onChange={(event) => update("to", event.target.value)} />
      </label>
    </form>
  );
}
